import { LOCKER_INACTIVE_TAG } from "@components/Lockers/_lib/constants";
import isLockerInactive from "@components/Lockers/_lib/isLockerInactive";

const LockerCardInactiveTag = ({ locker }) => {
  if (!isLockerInactive(locker)) {
    return null;
  }

  return (
    <span className="inline-block w-fit rounded-[4px] border border-[#F1C21B]/30 bg-[#FCF4D6] px-[8px] pb-[5px] pt-[4px] text-[12px] font-medium">
      {LOCKER_INACTIVE_TAG}
    </span>
  );
};

export default LockerCardInactiveTag;
